import { useForm, useWatch } from "react-hook-form";
import { useAuthStore } from "../../store/authStore"
import FormInputText from "../shared/FormInputText";
import { zodResolver } from "@hookform/resolvers/zod";

import * as z from "zod/v4";
import { sendToken, verifyToken } from "../../utils/apiUtils";
import Countdown from "../shared/Countdown";
import { useState } from "react";
import { ALLOWED_DOMAINS } from "../../utils/constants";

const VerifyToken = ({ email, ttl }) => {
    const { isAuthenticated, logIn } = useAuthStore()
    const [errorMessage, setErrorMessage] = useState()
    const {
        control,
        register,
        formState: { errors, isValid, isDirty, dirtyFields, isSubmitting, isSubmitSuccessful, },
        handleSubmit,
    } = useForm({
        resolver: zodResolver(
            z.object({
                email: z.email()
                    .refine(
                        (email) => {
                            const domain = email.split("@")[1]?.toLowerCase();
                            return ALLOWED_DOMAINS.includes(domain);
                        },
                        { error: (issue) => 'Domain not allowed' }
                    ),
                token: z.string().min(5).max(5)
            }),

        ),
        defaultValues: {
            email,

        },
        mode: "onSubmit"
    });

    // const values = useWatch({ control })
    const onSubmit = async (values) => {
        setErrorMessage()

        try {
            const result = await verifyToken(values)
            logIn(result)
        } catch (err) {
            setErrorMessage(err.message)
        }

    }

    const onError = async (err) => {
        setErrorMessage(err.message)
    }

    // console.log(errors['email'])
    // console.log({ errors, isValid, isDirty: Object.keys(dirtyFields).length })
    return (
        <div style={{ display: 'grid', placeItems: 'center', height: '80%' }}>


            <div style={{ width: '100%', maxWidth: '500px', padding: '1rem' }}>
                <div style={{ textAlign: 'center', padding: '0rem 0rem 3rem 0rem' }}>
                    <img
                        //src={centivoLog} 
                        src={"https://centivo.com/wp-content/themes/studio-simpatico/svgs/logo.svg"}
                        //        src="https://centivo.com/wp-content/themes/studio-simpatico/svgs/logo-c.svg"
                        alt="centivo-logo"
                    // width={180}
                    />
                </div>


                <div>
                    <p className="title">Verify token</p>
                    <p className="sub-title">Token has been sent to you at {email}</p>
                    <Countdown targetTimestamp={ttl} />


                    <form onSubmit={handleSubmit(onSubmit, onError)} className="form" style={{ paddingTop: '1rem' }}>
                        <FormInputText label={'Token'} name="token" register={register} errors={errors} placeholder="Token" disabled={isSubmitting} />
                        {errorMessage && <p className="danger" style={{ padding: '0rem 0rem 2rem 0rem' }}>{errorMessage}</p>}

                        {isSubmitting ? <div className="loader" /> : <input
                            className="btn"
                            type="submit"
                            disabled={Object.keys(dirtyFields).length && !isValid}
                            value={'Sign In'} />}


                    </form>


                </div>

            </div>

        </div >
    )
}


export default VerifyToken